var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 0.34668H1.66671C0.931374 0.34668 0.333374 0.950823 0.333374 1.69371V6.40832C0.333374 7.15121 0.931374 7.75536 1.66671 7.75536H5.00004C5.73537 7.75536 6.33337 7.15121 6.33337 6.40832V1.69371C6.33337 0.950823 5.73537 0.34668 5.00004 0.34668ZM12.3334 0.34668H9.00004C8.26471 0.34668 7.66671 0.950823 7.66671 1.69371V3.71426C7.66671 4.45715 8.26471 5.06129 9.00004 5.06129H12.3334C13.0687 5.06129 13.6667 4.45715 13.6667 3.71426V1.69371C13.6667 0.950823 13.0687 0.34668 12.3334 0.34668ZM5.00004 9.10239H1.66671C0.931374 9.10239 0.333374 9.70653 0.333374 10.4494V12.47C0.333374 13.2129 0.931374 13.817 1.66671 13.817H5.00004C5.73537 13.817 6.33337 13.2129 6.33337 12.47V10.4494C6.33337 9.70653 5.73537 9.10239 5.00004 9.10239ZM12.3334 6.40832H9.00004C8.26471 6.40832 7.66671 7.01247 7.66671 7.75536V12.47C7.66671 13.2129 8.26471 13.817 9.00004 13.817H12.3334C13.0687 13.817 13.6667 13.2129 13.6667 12.47V7.75536C13.6667 7.01247 13.0687 6.40832 12.3334 6.40832Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenu);
export default __webpack_public_path__ + "static/media/dashboardMenu.9811df3a721e8b4b68688847a5e0e5bd.svg";
export { ForwardRef as ReactComponent };